import { useEffect, useState } from 'react';

import CreateUser from './pages/NewUser/CreateUser';
import AdminDashboard from './pages/AdminDashboard';
import PendingList from './pages/NewUser/PendingList';
import CompletedList from './pages/NewUser/CompletedList';
import DeactivateUser from './pages/Deactivate/DeactivateUser';
import PendingDeactivation from './pages/Deactivate/PendingDeactivation';
import CompletedDeactivation from './pages/Deactivate/CompletedDeactivation';
import CreationStatus from './pages/BatchStatus/CreationStatus';
import DeactivationStatus from './pages/BatchStatus/DeactivationStatus';
import CompletedStatus from './pages/BatchStatus/CompletedStatus';
import Logout from './pages/Logout';
import ModifyUserInformation from './pages/ModifyUserInfo';
import ADPasswordReset from './pages/ADPasswordReset';
import ModifyNric from './pages/ModifyUserNRIC/ModifyNRIC';
import PendingModifyNric from './pages/ModifyUserNRIC/PendingList';
import CompletedModifyNric from './pages/ModifyUserNRIC/CompletedList';
// const useDynamicRoutes = () => {
// 	const [routes, setRoutes] = useState([]);

// 	useEffect(() => {
// 		let retries = 0;
// 		const maxRetries = 5;
// 		const retryInterval = 500; // 0.5 second

// 		const checkUserDetails = () => {
// 			let userDetails = {};
// 			try {
// 				userDetails =
// 					JSON.parse(localStorage.getItem('user-onboard-data')) || {};
// 			} catch (error) {
// 				console.error('Error parsing user data:', error);
// 			}

// 			const isAdmin =
// 				userDetails.onboardingAllowed === true && userDetails.isAdmin === 'Y';
// 			const isNormalUser =
// 				userDetails.onboardingAllowed === true && userDetails.isAdmin === 'N';

// 			if (!isAdmin && !isNormalUser && retries < maxRetries) {
// 				retries += 1;
// 				return;
// 			}

// 			const commonRoutes = [{ path: '/logout', element: <Logout /> }];

// 			if (isNormalUser) {
// 				setRoutes([
// 					{ path: 'new-user/create', element: <CreateUser /> },
// 					{ path: 'new-user/pending', element: <PendingList /> },
// 					{ path: 'new-user/completed', element: <CompletedList /> },
// 					{ path: 'deactivate-user/deactivate', element: <DeactivateUser /> },
// 					{ path: 'deactivate-user/pending', element: <PendingDeactivation /> },
// 					{
// 						path: 'deactivate-user/completed',
// 						element: <CompletedDeactivation />,
// 					},
// 					...commonRoutes,
// 				]);
// 			} else if (isAdmin) {
// 				setRoutes([
// 					{ path: 'admin/new-user/create', element: <CreateUser /> },
// 					{ path: 'admin/new-user/pending', element: <PendingList /> },
// 					{ path: 'admin/new-user/completed', element: <CompletedList /> },
// 					{
// 						path: 'admin/deactivate-user/deactivate',
// 						element: <DeactivateUser />,
// 					},
// 					{
// 						path: 'admin/deactivate-user/pending',
// 						element: <PendingDeactivation />,
// 					},
// 					{
// 						path: 'admin/deactivate-user/completed',
// 						element: <CompletedDeactivation />,
// 					},
// 					{ path: 'admin/batch-status/creation', element: <CreationStatus /> },
// 					{
// 						path: 'admin/batch-status/deactivation',
// 						element: <DeactivationStatus />,
// 					},
// 					{
// 						path: 'admin/batch-status/completed',
// 						element: <CompletedStatus />,
// 					},
// 					...commonRoutes,
// 				]);
// 			}

// 			clearInterval(interval);
// 		};

// 		const interval = setInterval(checkUserDetails, retryInterval);

// 		return () => clearInterval(interval);
// 	}, []);

// 	return routes;
// };

const useDynamicRoutes = () => {
	const [routes, setRoutes] = useState([]);

	useEffect(() => {
		let retries = 0;
		const maxRetries = 5;
		const retryInterval = 500; // 0.5 second

		const checkUserDetails = () => {
			let userDetails = {};
			try {
				userDetails =
					JSON.parse(localStorage.getItem('user-onboard-data')) || {};
			} catch (error) {
				console.error('Error parsing user data:', error);
			}

			const isAdmin =
				userDetails.onboardingAllowed === true && userDetails.isAdmin === 'Y';
			const isNormalUser =
				userDetails.onboardingAllowed === true && userDetails.isAdmin === 'N';

			if (!isAdmin && !isNormalUser && retries < maxRetries) {
				retries += 1;
				return;
			}

			const commonRoutes = [{ path: '/logout', element: <Logout /> }];

			if (isNormalUser) {
				setRoutes([
					{ path: '/new-user/create', element: <CreateUser /> },
					{ path: '/new-user/pending', element: <PendingList /> },
					{ path: '/new-user/completed', element: <CompletedList /> },
					{ path: '/deactivate-user/deactivate', element: <DeactivateUser /> },
					{
						path: '/deactivate-user/pending',
						element: <PendingDeactivation />,
					},
					{
						path: '/deactivate-user/completed',
						element: <CompletedDeactivation />,
					},
					{
						path: '/ModifyUserNRIC/ModifyNRIC',
						element: <ModifyNric />,
					},
					{
						path: '/ModifyUserNRIC/pending',
						element: <PendingModifyNric />,
					},
					{
						path: '/ModifyUserNRIC/completed',
						element: <CompletedModifyNric />,
					},
					...commonRoutes,
				]);
			} else if (isAdmin) {
				setRoutes([
					{ path: '/admin/dashboard', element: <AdminDashboard /> },
					{ path: '/admin/new-user/create', element: <CreateUser /> },
					{ path: '/admin/new-user/pending', element: <PendingList /> },
					{ path: '/admin/new-user/completed', element: <CompletedList /> },
					{
						path: '/admin/deactivate-user/deactivate',
						element: <DeactivateUser />,
					},
					{
						path: '/admin/deactivate-user/pending',
						element: <PendingDeactivation />,
					},
					{
						path: '/admin/deactivate-user/completed',
						element: <CompletedDeactivation />,
					},
					{
						path: '/admin/ModifyUserNRIC/ModifyNRIC',
						element: <ModifyNric />,
					},
					{
						path: '/admin/ModifyUserNRIC/pending',
						element: <PendingModifyNric />,
					},
					{
						path: '/admin/ModifyUserNRIC/completed',
						element: <CompletedModifyNric />,
					},
					{ path: '/admin/batch-status/creation', element: <CreationStatus /> },
					{
						path: '/admin/batch-status/deactivation',
						element: <DeactivationStatus />,
					},
					{
						path: '/admin/batch-status/completed',
						element: <CompletedStatus />,
					},
					{
						path: '/admin/modify-user-information',
						element: <ModifyUserInformation />,
					},
					{
						path: '/admin/ad-password-reset',
						element: <ADPasswordReset />,
					},
					...commonRoutes,
				]);
			}

			clearInterval(interval);
		};

		const interval = setInterval(checkUserDetails, retryInterval);

		return () => clearInterval(interval);
	}, []);

	return routes;
};

export default useDynamicRoutes;
